import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// utils
import { fetcher } from '@/utils/Axios';

// types
import { CustomerList, CustomerProps } from '@/types/customer';

const initialState: CustomerProps = {
  modal: false
};

export const endpoints = {
  key: 'api/customer',
  list: '/list', // server URL
  modal: '/modal', // server URL
  insert: '/insert', // server URL
  update: '/update', // server URL
  delete: '/delete' // server URL
};

export function useGetCustomer() {
  // const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.list, fetcher, {
  //   revalidateIfStale: false,
  //   revalidateOnFocus: false,
  //   revalidateOnReconnect: false
  // });

  // const memoizedValue = useMemo(
  //   () => ({
  //     customers: data?.customers as CustomerList[],
  //     customersLoading: isLoading,
  //     customersError: error,
  //     customersValidating: isValidating,
  //     customersEmpty: !isLoading && !data?.customers?.length
  //   }),
  //   [data, error, isLoading, isValidating]
  // );

  const data = {
    customers: [
      {
        firstName: 'Joe',
        lastName: 'Schilder',
        id: 1,
        avatar: 8,
        name: 'Joe Schilder',
        fatherName: 'Isaac McGee',
        email: 'sip@gmail.com',
        age: 39,
        gender: 'Female', // Assuming Gender is a string type
        userRole: 'Scientific Writer',
        orders: 9603,
        progress: 44,
        status: 3,
        orderStatus: 'Dispatched',
        contact: '(731) 342-9783',
        country: 'Canada',
        location: '1631 Melgu Square, Ujdeme, Maldives - 56391',
        about: 'Worbov fuggodbe uvawo za rimpewej uc wehele comi buan wam mes gacebu meb fupgop webkem gon enmile.',
        skills: ['Wireframing', 'Figma', 'Web App', 'ES6', 'UX', 'Javascript'],
        time: ['2 days ago'],
        date: '29.07.2023'
      },
      {
        firstName: 'Phoebe',
        lastName: 'Venturi',
        id: 2,
        avatar: 8,
        name: 'Phoebe Venturi',
        fatherName: 'Helen Stewart',
        email: 'ke@gmail.com',
        age: 52,
        gender: 'Female', // Gender should be a string or an enum
        userRole: 'Logistics Manager',
        orders: 7174,
        progress: 84,
        status: 1,
        orderStatus: 'Delivered',
        contact: '(887) 744-6950',
        country: 'Thailand',
        location: '1804 Ahedi Trail, Owottug, Bolivia - 47403',
        about: 'Udukaape gozune jig fu foslinan tadka kumu no guw upe or cifdasbej di ige.',
        skills: ['React', 'Mobile App', 'Prototyping', 'UX', 'Figma'],
        time: ['1 day ago'],
        date: '14.07.2023'
      },
      {
        firstName: 'Caroline',
        lastName: 'Pandolfi',
        id: 3,
        avatar: 4,
        name: 'Caroline Pandolfi',
        fatherName: 'Herbert Todd',
        email: 'secjavkib@gmail.com',
        age: 45,
        gender: 'Female',
        userRole: 'Physicist',
        orders: 2585,
        progress: 16,
        status: 1,
        orderStatus: 'Cancelled',
        contact: '(618) 787-3453',
        country: 'Barbados',
        location: '1060 Ejeaba Square, Wouruno, Congo - Kinshasa - 24456',
        about: 'Totug amuovve cakwud amlevat ja gepsi zan bulfivki mij dultej etuuf dakirpe.',
        skills: ['ES6', 'Figma', 'Backend', 'Mobile App', 'Javascript'],
        time: ['1 year ago'],
        date: '10.07.2023'
      },
      {
        firstName: 'Ricardo',
        lastName: 'Marchetti',
        id: 4,
        avatar: 5,
        name: 'Ricardo Marchetti',
        fatherName: 'Gerald Patterson',
        email: 'ho@gmail.com',
        age: 29,
        gender: 'Female',
        userRole: 'Banker',
        orders: 9283,
        progress: 48,
        status: 1,
        orderStatus: 'Refunded',
        contact: '(415) 628-7505',
        country: 'Italy',
        location: '1614 Fomwaj Square, Eknisra, Iceland - 41340',
        about: 'Riv mi hudgoh esviwoc usojipa vub palbesdu det vies pop rutsenazo viwwij esedakvu novfovih afjoda cimuwiec ebve.',
        skills: ['Codeigniter', 'Wireframing', 'Angular', 'Backend', 'UX', 'UI Design'],
        time: ['1 week ago'],
        date: '2.07.2023'
      },
      {
        firstName: 'Dorothy',
        lastName: 'Hussain',
        id: 5,
        avatar: 6,
        name: 'Dorothy Hussain',
        fatherName: 'Henrietta Griffin',
        email: 'socuih@gmail.com',
        age: 58,
        gender: 'Female',
        userRole: 'International Acct.',
        orders: 4872,
        progress: 26,
        status: 2,
        orderStatus: 'Delivered',
        contact: '(856) 459-8945',
        country: 'Mauritius',
        location: '1397 Morco Path, Gamarib, Malta - 65124',
        about: 'Avureput etluh iketi vosfo jamow do junabgog biw tovwenil fezpa aneow cizhel.',
        skills: ['Codeigniter', 'Angular', 'UI Design', 'Backend', 'React'],
        time: ['2 days ago'],
        date: '30.06.2023'
      },
      {
        firstName: 'Eleanor',
        lastName: 'Mann',
        id: 6,
        avatar: 2,
        name: 'Eleanor Mann',
        fatherName: 'Dollie Griffin',
        email: 'jonvok@gmail.com',
        age: 60,
        gender: 'Male',
        userRole: 'Design Engineer',
        orders: 499,
        progress: 8,
        status: 3,
        orderStatus: 'Dispatched',
        contact: '(507) 561-6927',
        country: 'American Samoa',
        location: '25 Odvaz Grove, Nadrubo, Belize - 93095',
        about: 'Ciaj dubeco muzogho bunwe ogtafa nij fizanul nopgoomu wuf hiwop tot ser wefoz uhe anaced.',
        skills: ['Codeigniter', 'Figma'],
        time: ['1 hour ago'],
        date: '22.06.2023'
      },
      {
        firstName: 'Nina',
        lastName: 'Francini',
        id: 7,
        avatar: 3,
        name: 'Nina Francini',
        fatherName: 'Danny Cohen',
        email: 'uhudadof@gmail.com',
        age: 27,
        gender: 'Male',
        userRole: 'Aerospace Engineer',
        orders: 3066,
        progress: 73,
        status: 1,
        orderStatus: 'Shipped',
        contact: '(722) 952-7792',
        country: 'Gibraltar',
        location: '1984 Faza Point, Wakukda, India - 94335',
        about: 'Besilija zomka nijiso puadehaz ve pi ecpogapo cotesen ceuje hohih ewuiw bo.',
        skills: ['Angular', 'Javascript', 'React'],
        time: ['1 hour ago'],
        date: '18.06.2023'
      },
      {
        firstName: 'Caroline',
        lastName: 'Mallet',
        id: 8,
        avatar: 5,
        name: 'Caroline Mallet',
        fatherName: 'Phoebe Hanson',
        email: 'peg@gmail.com',
        age: 26,
        gender: 'Female',
        userRole: 'Director',
        orders: 5478,
        progress: 24,
        status: 3,
        orderStatus: 'Processing',
        contact: '(675) 882-6307',
        country: 'Central African Republic',
        location: '725 Zehvo Highway, Puvoef, Japan - 93292',
        about: 'Asowag me ogetem gir joaw ki cuhug lakvo ujesa volhuj rettu powpa agoku va gajpah kinulov gechubte.',
        skills: ['Web App', 'Prototyping', 'Wireframing'],
        time: ['1 hour ago'],
        date: '5.06.2023'
      },
      {
        firstName: 'Amy',
        lastName: 'Pratt',
        id: 9,
        avatar: 3,
        name: 'Amy Pratt',
        fatherName: 'Harriett Gonzales',
        email: 'vavceriji@gmail.com',
        age: 47,
        gender: 'Female',
        userRole: 'Urban Planner',
        orders: 6255,
        progress: 6,
        status: 1,
        orderStatus: 'Refunded',
        contact: '(906) 966-2597',
        country: 'Indonesia',
        location: '333 Hinur Trail, Zepopde, Kiribati - 39279',
        about: 'Vo icu re da ula kumgajbeg fuhem wuwe doiso uvoege lu ipekocpub.',
        skills: ['Backend', 'UI Design'],
        time: ['5 months ago'],
        date: '31.05.2023'
      },
      {
        firstName: 'Gene',
        lastName: 'Montero',
        id: 10,
        avatar: 4,
        name: 'Gene Montero',
        fatherName: 'Mason Brady',
        email: 'rouca@gmail.com',
        age: 55,
        gender: 'Male',
        userRole: 'Administrator',
        orders: 702,
        progress: 62,
        status: 2,
        orderStatus: 'Delivered',
        contact: '(969) 819-7489',
        country: 'Yemen',
        location: '1409 Ifuwu Trail, Davdibun, Nepal - 22947',
        about: 'Ro atvawvih somhek nipdoni hotfaltab mujle etajevuj ra pev mi duzahi redka se mab dem rorjeab tel hiwehar.',
        skills: ['Javascript', 'Figma', 'HTML'],
        time: ['1 day ago'],
        date: '13.05.2023'
      },
      {
        firstName: 'Ollie',
        lastName: 'Barbetti',
        id: 11,
        avatar: 8,
        name: 'Ollie Barbetti',
        fatherName: 'Nina Stanley',
        email: 'bap@gmail.com',
        age: 64,
        gender: 'Female',
        userRole: 'City Housing Manager',
        orders: 8006,
        progress: 88,
        status: 2,
        orderStatus: 'Dispatched',
        contact: '(323) 498-6272',
        country: 'Central African Republic',
        location: '577 Zeoz Drive, Misoov, Martinique - 29073',
        about: 'Igalewuh idpowu tivwi zedro pidfufbic juz ot kor beb wopaeha ughema odi ebwuco ju.',
        skills: ['Javascript', 'Prototyping'],
        time: ['1 year ago'],
        date: '27.04.2023'
      },
      {
        firstName: 'Katherine',
        lastName: 'Olivier',
        id: 12,
        avatar: 4,
        name: 'Katherine Olivier',
        fatherName: 'Harold Fowler',
        email: 'newe@gmail.com',
        age: 41,
        gender: 'Female',
        userRole: 'Jeweler',
        orders: 261,
        progress: 68,
        status: 2,
        orderStatus: 'Completed',
        contact: '(740) 673-7034',
        country: 'Nicaragua',
        location: '1563 Kukrez River, Vegotaf, Tristan da Cunha - 54129',
        about: 'Gajvaj mam won wo azeovoz mo ki apa bukihroh po lati takobada.',
        skills: ['Figma', 'React'],
        time: ['2 days ago'],
        date: '6.04.2023'
      }
    ],
    isLoading: false,
    error: null,
    isValidating: false,
    customersEmpty: false
  };
  const memoizedValue = useMemo(
    () => ({
      customers: data?.customers as CustomerList[],
      customersLoading: data.isLoading,
      customersError: data.error,
      customersValidating: data.isValidating,
      customersEmpty: data.customersEmpty
    }),
    [data]
  );

  return memoizedValue;
}

export async function insertCustomer(newCustomer: CustomerList) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.list,
    (currentCustomer: any) => {
      newCustomer.id = currentCustomer.customers.length + 1;
      const addedCustomer: CustomerList[] = [...currentCustomer.customers, newCustomer];

      return {
        ...currentCustomer,
        customers: addedCustomer
      };
    },
    false
  );

  // to hit server
  // you may need to refetch latest data after server hit and based on your logic
  //   const data = { newCustomer };
  //   await Axios.post(endpoints.key + endpoints.insert, data);
}

export async function updateCustomer(customerId: number, updatedCustomer: CustomerList) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.list,
    (currentCustomer: any) => {
      const newCustomer: CustomerList[] = currentCustomer.customers.map((customer: CustomerList) =>
        customer.id === customerId ? { ...customer, ...updatedCustomer } : customer
      );

      return {
        ...currentCustomer,
        customers: newCustomer
      };
    },
    false
  );

  // to hit server
  // you may need to refetch latest data after server hit and based on your logic
  //   const data = { list: updatedCustomer };
  //   await Axios.post(endpoints.key + endpoints.update, data);
}

export async function deleteCustomer(customerId: number) {
  // to update local state based on key
  mutate(
    endpoints.key + endpoints.list,
    (currentCustomer: any) => {
      const nonDeletedCustomer = currentCustomer.customers.filter((customer: CustomerList) => customer.id !== customerId);

      return {
        ...currentCustomer,
        customers: nonDeletedCustomer
      };
    },
    false
  );

  // to hit server
  // you may need to refetch latest data after server hit and based on your logic
  //   const data = { customerId };
  //   await Axios.post(endpoints.key + endpoints.delete, data);
}

export function useGetCustomerMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.modal, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      customerMaster: data,
      customerMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerCustomerDialog(modal: boolean) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.modal,
    (currentCustomermaster: any) => {
      return { ...currentCustomermaster, modal };
    },
    false
  );
}
